/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignmentCreate } from '../models/AssignmentCreate';
import type { AssignmentDetail } from '../models/AssignmentDetail';
import type { AssignmentEventHistory } from '../models/AssignmentEventHistory';
import type { AssignmentExpenseCreate } from '../models/AssignmentExpenseCreate';
import type { AssignmentExpenseHistory } from '../models/AssignmentExpenseHistory';
import type { AssignmentExpenseList } from '../models/AssignmentExpenseList';
import type { AssignmentExpenseUpdate } from '../models/AssignmentExpenseUpdate';
import type { AssignmentHistory } from '../models/AssignmentHistory';
import type { AssignmentNote } from '../models/AssignmentNote';
import type { AssignmentRequest } from '../models/AssignmentRequest';
import type { AssignmentRequestCreate } from '../models/AssignmentRequestCreate';
import type { AssignmentShift } from '../models/AssignmentShift';
import type { AssignmentShiftHistory } from '../models/AssignmentShiftHistory';
import type { AssignmentShiftList } from '../models/AssignmentShiftList';
import type { AssignmentShiftStatusHistory } from '../models/AssignmentShiftStatusHistory';
import type { AssignmentStatusHistory } from '../models/AssignmentStatusHistory';
import type { BasicUser } from '../models/BasicUser';
import type { ExpenseCategory } from '../models/ExpenseCategory';
import type { OpportunityCreate } from '../models/OpportunityCreate';
import type { OpportunityDetail } from '../models/OpportunityDetail';
import type { OpportunityHistory } from '../models/OpportunityHistory';
import type { OpportunityNote } from '../models/OpportunityNote';
import type { OpportunityStatusHistory } from '../models/OpportunityStatusHistory';
import type { OpportunityUpdate } from '../models/OpportunityUpdate';
import type { PaginatedAssignmentExpenseListList } from '../models/PaginatedAssignmentExpenseListList';
import type { PaginatedAssignmentListList } from '../models/PaginatedAssignmentListList';
import type { PaginatedAssignmentNoteList } from '../models/PaginatedAssignmentNoteList';
import type { PaginatedOpportunityList } from '../models/PaginatedOpportunityList';
import type { PaginatedOpportunityNoteList } from '../models/PaginatedOpportunityNoteList';
import type { PaginatedTimeCardListList } from '../models/PaginatedTimeCardListList';
import type { PaginatedTimeCardNoteList } from '../models/PaginatedTimeCardNoteList';
import type { PatchedAssignmentDetail } from '../models/PatchedAssignmentDetail';
import type { PatchedAssignmentEventUpdate } from '../models/PatchedAssignmentEventUpdate';
import type { PatchedAssignmentExpenseUpdate } from '../models/PatchedAssignmentExpenseUpdate';
import type { PatchedAssignmentManagerUpdate } from '../models/PatchedAssignmentManagerUpdate';
import type { PatchedAssignmentNote } from '../models/PatchedAssignmentNote';
import type { PatchedAssignmentShift } from '../models/PatchedAssignmentShift';
import type { PatchedAssignmentStatusUpdate } from '../models/PatchedAssignmentStatusUpdate';
import type { PatchedOpportunityNote } from '../models/PatchedOpportunityNote';
import type { PatchedOpportunityStatusUpdate } from '../models/PatchedOpportunityStatusUpdate';
import type { PatchedOpportunityUpdate } from '../models/PatchedOpportunityUpdate';
import type { PatchedShiftChanges } from '../models/PatchedShiftChanges';
import type { PatchedShiftResponse } from '../models/PatchedShiftResponse';
import type { PatchedTimeCardNote } from '../models/PatchedTimeCardNote';
import type { PatchedTimeCardShift } from '../models/PatchedTimeCardShift';
import type { PatchedTimeCardShiftRemove } from '../models/PatchedTimeCardShiftRemove';
import type { PatchedTimeCardShiftUpdate } from '../models/PatchedTimeCardShiftUpdate';
import type { PatchedTimeCardStatusUpdate } from '../models/PatchedTimeCardStatusUpdate';
import type { ShiftChanges } from '../models/ShiftChanges';
import type { ShiftResponse } from '../models/ShiftResponse';
import type { TimeCardDetail } from '../models/TimeCardDetail';
import type { TimeCardEventHistory } from '../models/TimeCardEventHistory';
import type { TimeCardNote } from '../models/TimeCardNote';
import type { TimeCardShift } from '../models/TimeCardShift';
import type { TimeCardShiftCreate } from '../models/TimeCardShiftCreate';
import type { TimeCardShiftHistory } from '../models/TimeCardShiftHistory';
import type { TimeCardShiftUpdate } from '../models/TimeCardShiftUpdate';
import type { TimeCardStatusHistory } from '../models/TimeCardStatusHistory';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AssignmentsService {

    /**
     * @returns PaginatedAssignmentListList
     * @throws ApiError
     */
    public static assignmentsAssignmentList({
        endOnAfter,
        endOnBefore,
        facility,
        healthcareEntity,
        limit,
        mine,
        offset,
        ordering,
        provider,
        queue,
        reason,
        search,
        startOnAfter,
        startOnBefore,
        status,
        statusCategory,
        statusExclude,
        statusKind,
        unassigned,
    }: {
        endOnAfter?: string,
        endOnBefore?: string,
        facility?: string,
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        mine?: boolean,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        startOnAfter?: string,
        startOnBefore?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status (exclude)
         */
        statusExclude?: Array<string | null>,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
        unassigned?: boolean,
    }): CancelablePromise<PaginatedAssignmentListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/assignment/',
            query: {
                'end_on_after': endOnAfter,
                'end_on_before': endOnBefore,
                'facility': facility,
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'mine': mine,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'queue': queue,
                'reason': reason,
                'search': search,
                'start_on_after': startOnAfter,
                'start_on_before': startOnBefore,
                'status': status,
                'status_category': statusCategory,
                'status_exclude': statusExclude,
                'status_kind': statusKind,
                'unassigned': unassigned,
            },
        });
    }

    /**
     * @returns AssignmentCreate
     * @throws ApiError
     */
    public static assignmentsAssignmentCreate({
        requestBody,
    }: {
        requestBody: AssignmentCreate,
    }): CancelablePromise<AssignmentCreate> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/assignment/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AssignmentExpenseUpdate
     * @throws ApiError
     */
    public static assignmentsAssignmentExpenseUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Assignment Expense.
         */
        id: string,
        requestBody: AssignmentExpenseUpdate,
    }): CancelablePromise<AssignmentExpenseUpdate> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assignments/assignment-expense/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AssignmentExpenseUpdate
     * @throws ApiError
     */
    public static assignmentsAssignmentExpensePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Assignment Expense.
         */
        id: string,
        requestBody?: PatchedAssignmentExpenseUpdate,
    }): CancelablePromise<AssignmentExpenseUpdate> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/assignment-expense/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static assignmentsAssignmentExpenseDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Assignment Expense.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/assignments/assignment-expense/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Handles the retrieval of change history for an instance.
     * The change history can be sorted in ascending or descending
     * order based on a query parameter.
     *
     * Args:
     * request: The HTTP request object.
     * *args: Additional positional arguments.
     * **kwargs: Additional keyword arguments.
     *
     * Returns:
     * Response: A Response object containing the aggregated and sorted change history
     * data for the instance.
     *
     * Note:
     * The `sort` query parameter is optional and determines the sort order of the
     * change history. Valid values are `asc` (ascending) and `desc` (descending).
     * @returns AssignmentExpenseHistory
     * @throws ApiError
     */
    public static assignmentsAssignmentExpenseChangeHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Assignment Expense.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<AssignmentExpenseHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/assignment-expense/{id}/change-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns AssignmentNote
     * @throws ApiError
     */
    public static assignmentsAssignmentNoteUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Assignment Note.
         */
        id: string,
        requestBody: AssignmentNote,
    }): CancelablePromise<AssignmentNote> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assignments/assignment-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AssignmentNote
     * @throws ApiError
     */
    public static assignmentsAssignmentNotePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Assignment Note.
         */
        id: string,
        requestBody?: PatchedAssignmentNote,
    }): CancelablePromise<AssignmentNote> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/assignment-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static assignmentsAssignmentNoteDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Assignment Note.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/assignments/assignment-note/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Public-facing assignment request endpoint.
     * Known users (healthcare_entity_rep + connected_facility) create assignments.
     * Unknown users trigger email notifications for manual processing.
     * @returns AssignmentRequestCreate
     * @throws ApiError
     */
    public static assignmentsAssignmentRequestCreate({
        requestBody,
    }: {
        requestBody: AssignmentRequestCreate,
    }): CancelablePromise<AssignmentRequestCreate> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/assignment-request/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AssignmentShiftList
     * @throws ApiError
     */
    public static assignmentsAssignmentShiftList({
        provider,
        startOnAfter,
        startOnBefore,
    }: {
        provider?: string,
        startOnAfter?: string,
        startOnBefore?: string,
    }): CancelablePromise<Array<AssignmentShiftList>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/assignment-shift/',
            query: {
                'provider': provider,
                'start_on_after': startOnAfter,
                'start_on_before': startOnBefore,
            },
        });
    }

    /**
     * @returns AssignmentShift
     * @throws ApiError
     */
    public static assignmentsAssignmentShiftRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this assignment shift.
         */
        id: string,
    }): CancelablePromise<AssignmentShift> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/assignment-shift/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Handles the retrieval of change history for an instance.
     * The change history can be sorted in ascending or descending
     * order based on a query parameter.
     *
     * Args:
     * request: The HTTP request object.
     * *args: Additional positional arguments.
     * **kwargs: Additional keyword arguments.
     *
     * Returns:
     * Response: A Response object containing the aggregated and sorted change history
     * data for the instance.
     *
     * Note:
     * The `sort` query parameter is optional and determines the sort order of the
     * change history. Valid values are `asc` (ascending) and `desc` (descending).
     * @returns AssignmentShiftHistory
     * @throws ApiError
     */
    public static assignmentsAssignmentShiftChangeHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this assignment shift.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<AssignmentShiftHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/assignment-shift/{id}/change-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns AssignmentShiftStatusHistory
     * @throws ApiError
     */
    public static assignmentsAssignmentShiftStatusHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this assignment shift.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<AssignmentShiftStatusHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/assignment-shift/{id}/status-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns AssignmentShift
     * @throws ApiError
     */
    public static assignmentsAssignmentShiftStatusUpdatePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this assignment shift.
         */
        id: string,
        requestBody?: PatchedAssignmentShift,
    }): CancelablePromise<AssignmentShift> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/assignment-shift/{id}/status-update/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AssignmentDetail
     * @throws ApiError
     */
    public static assignmentsAssignmentRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
    }): CancelablePromise<AssignmentDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/assignment/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns AssignmentDetail
     * @throws ApiError
     */
    public static assignmentsAssignmentUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        requestBody: AssignmentDetail,
    }): CancelablePromise<AssignmentDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assignments/assignment/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AssignmentDetail
     * @throws ApiError
     */
    public static assignmentsAssignmentPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        requestBody?: PatchedAssignmentDetail,
    }): CancelablePromise<AssignmentDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/assignment/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Handles the retrieval of change history for an instance.
     * The change history can be sorted in ascending or descending
     * order based on a query parameter.
     *
     * Args:
     * request: The HTTP request object.
     * *args: Additional positional arguments.
     * **kwargs: Additional keyword arguments.
     *
     * Returns:
     * Response: A Response object containing the aggregated and sorted change history
     * data for the instance.
     *
     * Note:
     * The `sort` query parameter is optional and determines the sort order of the
     * change history. Valid values are `asc` (ascending) and `desc` (descending).
     * @returns AssignmentHistory
     * @throws ApiError
     */
    public static assignmentsAssignmentChangeHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<AssignmentHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/assignment/{id}/change-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns AssignmentEventHistory
     * @throws ApiError
     */
    public static assignmentsAssignmentEventHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<AssignmentEventHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/assignment/{id}/event-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns AssignmentDetail
     * @throws ApiError
     */
    public static assignmentsAssignmentEventUpdatePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        requestBody?: PatchedAssignmentEventUpdate,
    }): CancelablePromise<AssignmentDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/assignment/{id}/event-update/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PaginatedAssignmentExpenseListList
     * @returns AssignmentExpenseList
     * @throws ApiError
     */
    public static assignmentsAssignmentExpensesList({
        id,
        endOnAfter,
        endOnBefore,
        facility,
        healthcareEntity,
        limit,
        mine,
        offset,
        ordering,
        provider,
        queue,
        reason,
        search,
        startOnAfter,
        startOnBefore,
        status,
        statusCategory,
        statusExclude,
        statusKind,
        unassigned,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        endOnAfter?: string,
        endOnBefore?: string,
        facility?: string,
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        mine?: boolean,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        startOnAfter?: string,
        startOnBefore?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status (exclude)
         */
        statusExclude?: Array<string | null>,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
        unassigned?: boolean,
    }): CancelablePromise<PaginatedAssignmentExpenseListList | AssignmentExpenseList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/assignment/{id}/expenses/',
            path: {
                'id': id,
            },
            query: {
                'end_on_after': endOnAfter,
                'end_on_before': endOnBefore,
                'facility': facility,
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'mine': mine,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'queue': queue,
                'reason': reason,
                'search': search,
                'start_on_after': startOnAfter,
                'start_on_before': startOnBefore,
                'status': status,
                'status_category': statusCategory,
                'status_exclude': statusExclude,
                'status_kind': statusKind,
                'unassigned': unassigned,
            },
        });
    }

    /**
     * @returns PaginatedAssignmentExpenseListList
     * @returns AssignmentExpenseList
     * @throws ApiError
     */
    public static assignmentsAssignmentExpensesCreate({
        id,
        requestBody,
        endOnAfter,
        endOnBefore,
        facility,
        healthcareEntity,
        limit,
        mine,
        offset,
        ordering,
        provider,
        queue,
        reason,
        search,
        startOnAfter,
        startOnBefore,
        status,
        statusCategory,
        statusExclude,
        statusKind,
        unassigned,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        requestBody: AssignmentExpenseCreate,
        endOnAfter?: string,
        endOnBefore?: string,
        facility?: string,
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        mine?: boolean,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        startOnAfter?: string,
        startOnBefore?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status (exclude)
         */
        statusExclude?: Array<string | null>,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
        unassigned?: boolean,
    }): CancelablePromise<PaginatedAssignmentExpenseListList | AssignmentExpenseList> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/assignment/{id}/expenses/',
            path: {
                'id': id,
            },
            query: {
                'end_on_after': endOnAfter,
                'end_on_before': endOnBefore,
                'facility': facility,
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'mine': mine,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'queue': queue,
                'reason': reason,
                'search': search,
                'start_on_after': startOnAfter,
                'start_on_before': startOnBefore,
                'status': status,
                'status_category': statusCategory,
                'status_exclude': statusExclude,
                'status_kind': statusKind,
                'unassigned': unassigned,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Update `managed_by` on an assignment. Accepts null (Unassign), the
     * requesting user (Assign to me, allowed for any audience), or a User
     * from the eligible-manager set for the assignment's entity.
     * @returns AssignmentDetail
     * @throws ApiError
     */
    public static assignmentsAssignmentManagerUpdatePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        requestBody?: PatchedAssignmentManagerUpdate,
    }): CancelablePromise<AssignmentDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/assignment/{id}/manager-update/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PaginatedAssignmentNoteList
     * @returns AssignmentNote
     * @throws ApiError
     */
    public static assignmentsAssignmentNotesList({
        id,
        endOnAfter,
        endOnBefore,
        facility,
        healthcareEntity,
        limit,
        mine,
        offset,
        ordering,
        provider,
        queue,
        reason,
        search,
        sort,
        startOnAfter,
        startOnBefore,
        status,
        statusCategory,
        statusExclude,
        statusKind,
        unassigned,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        endOnAfter?: string,
        endOnBefore?: string,
        facility?: string,
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        mine?: boolean,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        startOnAfter?: string,
        startOnBefore?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status (exclude)
         */
        statusExclude?: Array<string | null>,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
        unassigned?: boolean,
    }): CancelablePromise<PaginatedAssignmentNoteList | AssignmentNote> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/assignment/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'end_on_after': endOnAfter,
                'end_on_before': endOnBefore,
                'facility': facility,
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'mine': mine,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'queue': queue,
                'reason': reason,
                'search': search,
                'sort': sort,
                'start_on_after': startOnAfter,
                'start_on_before': startOnBefore,
                'status': status,
                'status_category': statusCategory,
                'status_exclude': statusExclude,
                'status_kind': statusKind,
                'unassigned': unassigned,
            },
        });
    }

    /**
     * @returns PaginatedAssignmentNoteList
     * @returns AssignmentNote
     * @throws ApiError
     */
    public static assignmentsAssignmentNotesCreate({
        id,
        requestBody,
        endOnAfter,
        endOnBefore,
        facility,
        healthcareEntity,
        limit,
        mine,
        offset,
        ordering,
        provider,
        queue,
        reason,
        search,
        sort,
        startOnAfter,
        startOnBefore,
        status,
        statusCategory,
        statusExclude,
        statusKind,
        unassigned,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        requestBody: AssignmentNote,
        endOnAfter?: string,
        endOnBefore?: string,
        facility?: string,
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        mine?: boolean,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        startOnAfter?: string,
        startOnBefore?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status (exclude)
         */
        statusExclude?: Array<string | null>,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
        unassigned?: boolean,
    }): CancelablePromise<PaginatedAssignmentNoteList | AssignmentNote> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/assignment/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'end_on_after': endOnAfter,
                'end_on_before': endOnBefore,
                'facility': facility,
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'mine': mine,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'queue': queue,
                'reason': reason,
                'search': search,
                'sort': sort,
                'start_on_after': startOnAfter,
                'start_on_before': startOnBefore,
                'status': status,
                'status_category': statusCategory,
                'status_exclude': statusExclude,
                'status_kind': statusKind,
                'unassigned': unassigned,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ShiftResponse
     * @throws ApiError
     */
    public static assignmentsAssignmentProviderShiftStatusUpdatePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        requestBody?: PatchedShiftResponse,
    }): CancelablePromise<ShiftResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/assignment/{id}/provider-shift-status-update/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ShiftChanges
     * @throws ApiError
     */
    public static assignmentsAssignmentShiftChangesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        requestBody?: PatchedShiftChanges,
    }): CancelablePromise<ShiftChanges> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/assignment/{id}/shift-changes/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AssignmentStatusHistory
     * @throws ApiError
     */
    public static assignmentsAssignmentStatusHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<AssignmentStatusHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/assignment/{id}/status-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns AssignmentDetail
     * @throws ApiError
     */
    public static assignmentsAssignmentStatusUpdatePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this assignment.
         */
        id: string,
        requestBody?: PatchedAssignmentStatusUpdate,
    }): CancelablePromise<AssignmentDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/assignment/{id}/status-update/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Return Users who can be set as `managed_by` for assignments belonging
     * to the given healthcare entity. Includes active reps of the entity
     * whose currently-effective auth groups grant
     * `update__assignments__assignment`. Sorted by first / last name.
     * @returns BasicUser
     * @throws ApiError
     */
    public static assignmentsAssignmentEligibleManagersList({
        healthcareEntity,
        endOnAfter,
        endOnBefore,
        facility,
        mine,
        ordering,
        provider,
        queue,
        reason,
        search,
        startOnAfter,
        startOnBefore,
        status,
        statusCategory,
        statusExclude,
        statusKind,
        unassigned,
    }: {
        healthcareEntity: string,
        endOnAfter?: string,
        endOnBefore?: string,
        facility?: string,
        mine?: boolean,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        startOnAfter?: string,
        startOnBefore?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status (exclude)
         */
        statusExclude?: Array<string | null>,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
        unassigned?: boolean,
    }): CancelablePromise<Array<BasicUser>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/assignment/eligible-managers/',
            query: {
                'end_on_after': endOnAfter,
                'end_on_before': endOnBefore,
                'facility': facility,
                'healthcare_entity': healthcareEntity,
                'mine': mine,
                'ordering': ordering,
                'provider': provider,
                'queue': queue,
                'reason': reason,
                'search': search,
                'start_on_after': startOnAfter,
                'start_on_before': startOnBefore,
                'status': status,
                'status_category': statusCategory,
                'status_exclude': statusExclude,
                'status_kind': statusKind,
                'unassigned': unassigned,
            },
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static assignmentsCalendarIcsCancellationRetrieve({
        assignmentId,
    }: {
        assignmentId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/calendar-ics-cancellation/{assignment_id}/',
            path: {
                'assignment_id': assignmentId,
            },
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static assignmentsCalendarIcsRetrieve({
        assignmentId,
    }: {
        assignmentId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/calendar-ics/{assignment_id}/',
            path: {
                'assignment_id': assignmentId,
            },
        });
    }

    /**
     * @returns ExpenseCategory
     * @throws ApiError
     */
    public static assignmentsExpenseCategoryList(): CancelablePromise<Array<ExpenseCategory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/expense-category/',
        });
    }

    /**
     * @returns PaginatedOpportunityList
     * @throws ApiError
     */
    public static assignmentsOpportunitiesList({
        currentStatus,
        currentStatusCategory,
        facilityId,
        healthcareEntityId,
        limit,
        offset,
        ordering,
        queue,
        search,
        specialties,
        state,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * Short code representation of the status for viewing and reports
         */
        currentStatus?: string,
        /**
         * Short code representation of the status category for viewing and reports
         */
        currentStatusCategory?: string,
        facilityId?: string,
        healthcareEntityId?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * A search term.
         */
        search?: string,
        /**
         * Specialties
         *
         * * `ANESTHESIA` - Anesthesiology
         * * `CARDIOVASCULAR_DISEASE` - Cardiovascular Disease
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospital Medicine
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_ANESTHESIA` - Pediatric Anesthesia
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialties?: Array<'ANESTHESIA' | 'CARDIOVASCULAR_DISEASE' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_ANESTHESIA' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY'>,
        /**
         * State
         *
         * * `AK` - Alaska
         * * `AL` - Alabama
         * * `AR` - Arkansas
         * * `AZ` - Arizona
         * * `CA` - California
         * * `CO` - Colorado
         * * `CT` - Connecticut
         * * `DC` - District of Columbia
         * * `DE` - Delaware
         * * `FL` - Florida
         * * `GA` - Georgia
         * * `HI` - Hawaii
         * * `IA` - Iowa
         * * `ID` - Idaho
         * * `IL` - Illinois
         * * `IN` - Indiana
         * * `KS` - Kansas
         * * `KY` - Kentucky
         * * `LA` - Louisiana
         * * `MA` - Massachusetts
         * * `MD` - Maryland
         * * `ME` - Maine
         * * `MI` - Michigan
         * * `MN` - Minnesota
         * * `MO` - Missouri
         * * `MS` - Mississippi
         * * `MT` - Montana
         * * `NC` - North Carolina
         * * `ND` - North Dakota
         * * `NE` - Nebraska
         * * `NH` - New Hampshire
         * * `NJ` - New Jersey
         * * `NM` - New Mexico
         * * `NV` - Nevada
         * * `NY` - New York
         * * `OH` - Ohio
         * * `OK` - Oklahoma
         * * `OR` - Oregon
         * * `PA` - Pennsylvania
         * * `RI` - Rhode Island
         * * `SC` - South Carolina
         * * `SD` - South Dakota
         * * `TN` - Tennessee
         * * `TX` - Texas
         * * `UT` - Utah
         * * `VA` - Virginia
         * * `VI` - Virgin Islands
         * * `VT` - Vermont
         * * `WA` - Washington
         * * `WI` - Wisconsin
         * * `WV` - West Virginia
         * * `WY` - Wyoming
         */
        state?: Array<'AK' | 'AL' | 'AR' | 'AZ' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'IA' | 'ID' | 'IL' | 'IN' | 'KS' | 'KY' | 'LA' | 'MA' | 'MD' | 'ME' | 'MI' | 'MN' | 'MO' | 'MS' | 'MT' | 'NC' | 'ND' | 'NE' | 'NH' | 'NJ' | 'NM' | 'NV' | 'NY' | 'OH' | 'OK' | 'OR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VA' | 'VI' | 'VT' | 'WA' | 'WI' | 'WV' | 'WY'>,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedOpportunityList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/opportunities/',
            query: {
                'current_status': currentStatus,
                'current_status__category': currentStatusCategory,
                'facility_id': facilityId,
                'healthcare_entity_id': healthcareEntityId,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'search': search,
                'specialties': specialties,
                'state': state,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
        });
    }

    /**
     * @returns OpportunityDetail
     * @throws ApiError
     */
    public static assignmentsOpportunitiesCreate({
        requestBody,
    }: {
        requestBody: OpportunityCreate,
    }): CancelablePromise<OpportunityDetail> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/opportunities/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OpportunityNote
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNoteUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity Note.
         */
        id: string,
        requestBody: OpportunityNote,
    }): CancelablePromise<OpportunityNote> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assignments/opportunities-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OpportunityNote
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNotePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity Note.
         */
        id: string,
        requestBody?: PatchedOpportunityNote,
    }): CancelablePromise<OpportunityNote> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/opportunities-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNoteDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Opportunity Note.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/assignments/opportunities-note/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns OpportunityDetail
     * @throws ApiError
     */
    public static assignmentsOpportunitiesRetrieve({
        id,
        provider,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        /**
         * Provider ID for rates
         */
        provider?: string,
    }): CancelablePromise<OpportunityDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/opportunities/{id}/',
            path: {
                'id': id,
            },
            query: {
                'provider': provider,
            },
        });
    }

    /**
     * @returns OpportunityDetail
     * @throws ApiError
     */
    public static assignmentsOpportunitiesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        requestBody?: OpportunityUpdate,
    }): CancelablePromise<OpportunityDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assignments/opportunities/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OpportunityUpdate
     * @throws ApiError
     */
    public static assignmentsOpportunitiesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        requestBody?: PatchedOpportunityUpdate,
    }): CancelablePromise<OpportunityUpdate> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/opportunities/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static assignmentsOpportunitiesDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/assignments/opportunities/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * !! Custom changes history that merges two kinds of history
     *
     * Handles the retrieval of change history for an Opportunity instance and its related
     * OpportunitySettings. The change history can be sorted in ascending or descending
     * order based on a query parameter.
     *
     * Args:
     * request: The HTTP request object.
     * *args: Additional positional arguments.
     * **kwargs: Additional keyword arguments.
     *
     * Returns:
     * Response: A Response object containing the aggregated and sorted change history
     * data for the Opportunity and its related OpportunitySettings.
     *
     * Raises:
     * Does not explicitly describe raised errors in this method.
     *
     * Note:
     * The `sort` query parameter is optional and determines the sort order of the
     * change history. Valid values are `asc` (ascending) and `desc` (descending).
     * @returns OpportunityHistory
     * @throws ApiError
     */
    public static assignmentsOpportunitiesChangeHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<OpportunityHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/opportunities/{id}/change-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns PaginatedOpportunityNoteList
     * @returns OpportunityNote
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNotesList({
        id,
        currentStatus,
        currentStatusCategory,
        facilityId,
        healthcareEntityId,
        limit,
        offset,
        ordering,
        queue,
        search,
        sort,
        specialties,
        state,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        /**
         * Short code representation of the status for viewing and reports
         */
        currentStatus?: string,
        /**
         * Short code representation of the status category for viewing and reports
         */
        currentStatusCategory?: string,
        facilityId?: string,
        healthcareEntityId?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        /**
         * Specialties
         *
         * * `ANESTHESIA` - Anesthesiology
         * * `CARDIOVASCULAR_DISEASE` - Cardiovascular Disease
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospital Medicine
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_ANESTHESIA` - Pediatric Anesthesia
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialties?: Array<'ANESTHESIA' | 'CARDIOVASCULAR_DISEASE' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_ANESTHESIA' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY'>,
        /**
         * State
         *
         * * `AK` - Alaska
         * * `AL` - Alabama
         * * `AR` - Arkansas
         * * `AZ` - Arizona
         * * `CA` - California
         * * `CO` - Colorado
         * * `CT` - Connecticut
         * * `DC` - District of Columbia
         * * `DE` - Delaware
         * * `FL` - Florida
         * * `GA` - Georgia
         * * `HI` - Hawaii
         * * `IA` - Iowa
         * * `ID` - Idaho
         * * `IL` - Illinois
         * * `IN` - Indiana
         * * `KS` - Kansas
         * * `KY` - Kentucky
         * * `LA` - Louisiana
         * * `MA` - Massachusetts
         * * `MD` - Maryland
         * * `ME` - Maine
         * * `MI` - Michigan
         * * `MN` - Minnesota
         * * `MO` - Missouri
         * * `MS` - Mississippi
         * * `MT` - Montana
         * * `NC` - North Carolina
         * * `ND` - North Dakota
         * * `NE` - Nebraska
         * * `NH` - New Hampshire
         * * `NJ` - New Jersey
         * * `NM` - New Mexico
         * * `NV` - Nevada
         * * `NY` - New York
         * * `OH` - Ohio
         * * `OK` - Oklahoma
         * * `OR` - Oregon
         * * `PA` - Pennsylvania
         * * `RI` - Rhode Island
         * * `SC` - South Carolina
         * * `SD` - South Dakota
         * * `TN` - Tennessee
         * * `TX` - Texas
         * * `UT` - Utah
         * * `VA` - Virginia
         * * `VI` - Virgin Islands
         * * `VT` - Vermont
         * * `WA` - Washington
         * * `WI` - Wisconsin
         * * `WV` - West Virginia
         * * `WY` - Wyoming
         */
        state?: Array<'AK' | 'AL' | 'AR' | 'AZ' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'IA' | 'ID' | 'IL' | 'IN' | 'KS' | 'KY' | 'LA' | 'MA' | 'MD' | 'ME' | 'MI' | 'MN' | 'MO' | 'MS' | 'MT' | 'NC' | 'ND' | 'NE' | 'NH' | 'NJ' | 'NM' | 'NV' | 'NY' | 'OH' | 'OK' | 'OR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VA' | 'VI' | 'VT' | 'WA' | 'WI' | 'WV' | 'WY'>,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedOpportunityNoteList | OpportunityNote> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/opportunities/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'current_status': currentStatus,
                'current_status__category': currentStatusCategory,
                'facility_id': facilityId,
                'healthcare_entity_id': healthcareEntityId,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'search': search,
                'sort': sort,
                'specialties': specialties,
                'state': state,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
        });
    }

    /**
     * @returns PaginatedOpportunityNoteList
     * @returns OpportunityNote
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNotesCreate({
        id,
        requestBody,
        currentStatus,
        currentStatusCategory,
        facilityId,
        healthcareEntityId,
        limit,
        offset,
        ordering,
        queue,
        search,
        sort,
        specialties,
        state,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        requestBody: OpportunityNote,
        /**
         * Short code representation of the status for viewing and reports
         */
        currentStatus?: string,
        /**
         * Short code representation of the status category for viewing and reports
         */
        currentStatusCategory?: string,
        facilityId?: string,
        healthcareEntityId?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        /**
         * Specialties
         *
         * * `ANESTHESIA` - Anesthesiology
         * * `CARDIOVASCULAR_DISEASE` - Cardiovascular Disease
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospital Medicine
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_ANESTHESIA` - Pediatric Anesthesia
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialties?: Array<'ANESTHESIA' | 'CARDIOVASCULAR_DISEASE' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_ANESTHESIA' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY'>,
        /**
         * State
         *
         * * `AK` - Alaska
         * * `AL` - Alabama
         * * `AR` - Arkansas
         * * `AZ` - Arizona
         * * `CA` - California
         * * `CO` - Colorado
         * * `CT` - Connecticut
         * * `DC` - District of Columbia
         * * `DE` - Delaware
         * * `FL` - Florida
         * * `GA` - Georgia
         * * `HI` - Hawaii
         * * `IA` - Iowa
         * * `ID` - Idaho
         * * `IL` - Illinois
         * * `IN` - Indiana
         * * `KS` - Kansas
         * * `KY` - Kentucky
         * * `LA` - Louisiana
         * * `MA` - Massachusetts
         * * `MD` - Maryland
         * * `ME` - Maine
         * * `MI` - Michigan
         * * `MN` - Minnesota
         * * `MO` - Missouri
         * * `MS` - Mississippi
         * * `MT` - Montana
         * * `NC` - North Carolina
         * * `ND` - North Dakota
         * * `NE` - Nebraska
         * * `NH` - New Hampshire
         * * `NJ` - New Jersey
         * * `NM` - New Mexico
         * * `NV` - Nevada
         * * `NY` - New York
         * * `OH` - Ohio
         * * `OK` - Oklahoma
         * * `OR` - Oregon
         * * `PA` - Pennsylvania
         * * `RI` - Rhode Island
         * * `SC` - South Carolina
         * * `SD` - South Dakota
         * * `TN` - Tennessee
         * * `TX` - Texas
         * * `UT` - Utah
         * * `VA` - Virginia
         * * `VI` - Virgin Islands
         * * `VT` - Vermont
         * * `WA` - Washington
         * * `WI` - Wisconsin
         * * `WV` - West Virginia
         * * `WY` - Wyoming
         */
        state?: Array<'AK' | 'AL' | 'AR' | 'AZ' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'IA' | 'ID' | 'IL' | 'IN' | 'KS' | 'KY' | 'LA' | 'MA' | 'MD' | 'ME' | 'MI' | 'MN' | 'MO' | 'MS' | 'MT' | 'NC' | 'ND' | 'NE' | 'NH' | 'NJ' | 'NM' | 'NV' | 'NY' | 'OH' | 'OK' | 'OR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VA' | 'VI' | 'VT' | 'WA' | 'WI' | 'WV' | 'WY'>,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedOpportunityNoteList | OpportunityNote> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/opportunities/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'current_status': currentStatus,
                'current_status__category': currentStatusCategory,
                'facility_id': facilityId,
                'healthcare_entity_id': healthcareEntityId,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'search': search,
                'sort': sort,
                'specialties': specialties,
                'state': state,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OpportunityStatusHistory
     * @throws ApiError
     */
    public static assignmentsOpportunitiesStatusHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<OpportunityStatusHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/opportunities/{id}/status-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns OpportunityDetail
     * @throws ApiError
     */
    public static assignmentsOpportunitiesStatusUpdatePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        requestBody?: PatchedOpportunityStatusUpdate,
    }): CancelablePromise<OpportunityDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/opportunities/{id}/status-update/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AssignmentRequest
     * @throws ApiError
     */
    public static assignmentsRequestsCreate({
        requestBody,
    }: {
        requestBody: AssignmentRequest,
    }): CancelablePromise<AssignmentRequest> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/requests/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PaginatedTimeCardListList
     * @throws ApiError
     */
    public static assignmentsTimecardList({
        assignment,
        endOnAfter,
        endOnBefore,
        healthcareEntity,
        limit,
        offset,
        ordering,
        queue,
        reason,
        search,
        startOnAfter,
        startOnBefore,
        status,
        statusCategory,
        statusKind,
    }: {
        assignment?: string,
        endOnAfter?: string,
        endOnBefore?: string,
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * Reason
         */
        reason?: Array<string>,
        /**
         * A search term.
         */
        search?: string,
        startOnAfter?: string,
        startOnBefore?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedTimeCardListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/timecard/',
            query: {
                'assignment': assignment,
                'end_on_after': endOnAfter,
                'end_on_before': endOnBefore,
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'reason': reason,
                'search': search,
                'start_on_after': startOnAfter,
                'start_on_before': startOnBefore,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
        });
    }

    /**
     * @returns TimeCardDetail
     * @throws ApiError
     */
    public static assignmentsTimecardCreate({
        requestBody,
    }: {
        requestBody: TimeCardDetail,
    }): CancelablePromise<TimeCardDetail> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/timecard/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AssignmentExpenseUpdate
     * @throws ApiError
     */
    public static assignmentsTimecardExpenseUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Assignment Expense.
         */
        id: string,
        requestBody: AssignmentExpenseUpdate,
    }): CancelablePromise<AssignmentExpenseUpdate> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assignments/timecard-expense/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AssignmentExpenseUpdate
     * @throws ApiError
     */
    public static assignmentsTimecardExpensePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Assignment Expense.
         */
        id: string,
        requestBody?: PatchedAssignmentExpenseUpdate,
    }): CancelablePromise<AssignmentExpenseUpdate> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/timecard-expense/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static assignmentsTimecardExpenseDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Assignment Expense.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/assignments/timecard-expense/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Handles the retrieval of change history for an instance.
     * The change history can be sorted in ascending or descending
     * order based on a query parameter.
     *
     * Args:
     * request: The HTTP request object.
     * *args: Additional positional arguments.
     * **kwargs: Additional keyword arguments.
     *
     * Returns:
     * Response: A Response object containing the aggregated and sorted change history
     * data for the instance.
     *
     * Note:
     * The `sort` query parameter is optional and determines the sort order of the
     * change history. Valid values are `asc` (ascending) and `desc` (descending).
     * @returns AssignmentExpenseHistory
     * @throws ApiError
     */
    public static assignmentsTimecardExpenseChangeHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Assignment Expense.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<AssignmentExpenseHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/timecard-expense/{id}/change-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns TimeCardNote
     * @throws ApiError
     */
    public static assignmentsTimecardNoteUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Time Card Note.
         */
        id: string,
        requestBody: TimeCardNote,
    }): CancelablePromise<TimeCardNote> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assignments/timecard-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns TimeCardNote
     * @throws ApiError
     */
    public static assignmentsTimecardNotePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Time Card Note.
         */
        id: string,
        requestBody?: PatchedTimeCardNote,
    }): CancelablePromise<TimeCardNote> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/timecard-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static assignmentsTimecardNoteDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Time Card Note.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/assignments/timecard-note/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns TimeCardShiftCreate
     * @throws ApiError
     */
    public static assignmentsTimecardShiftCreate({
        requestBody,
    }: {
        requestBody: TimeCardShiftCreate,
    }): CancelablePromise<TimeCardShiftCreate> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/timecard-shift/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns TimeCardShift
     * @throws ApiError
     */
    public static assignmentsTimecardShiftRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this Time Card Shift.
         */
        id: string,
    }): CancelablePromise<TimeCardShift> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/timecard-shift/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns TimeCardShiftUpdate
     * @throws ApiError
     */
    public static assignmentsTimecardShiftUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Time Card Shift.
         */
        id: string,
        requestBody?: TimeCardShiftUpdate,
    }): CancelablePromise<TimeCardShiftUpdate> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assignments/timecard-shift/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns TimeCardShiftUpdate
     * @throws ApiError
     */
    public static assignmentsTimecardShiftPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Time Card Shift.
         */
        id: string,
        requestBody?: PatchedTimeCardShiftUpdate,
    }): CancelablePromise<TimeCardShiftUpdate> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/timecard-shift/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Handles the retrieval of change history for an instance.
     * The change history can be sorted in ascending or descending
     * order based on a query parameter.
     *
     * Args:
     * request: The HTTP request object.
     * *args: Additional positional arguments.
     * **kwargs: Additional keyword arguments.
     *
     * Returns:
     * Response: A Response object containing the aggregated and sorted change history
     * data for the instance.
     *
     * Note:
     * The `sort` query parameter is optional and determines the sort order of the
     * change history. Valid values are `asc` (ascending) and `desc` (descending).
     * @returns TimeCardShiftHistory
     * @throws ApiError
     */
    public static assignmentsTimecardShiftChangeHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Time Card Shift.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<TimeCardShiftHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/timecard-shift/{id}/change-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns TimeCardShift
     * @throws ApiError
     */
    public static assignmentsTimecardShiftRemovePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Time Card Shift.
         */
        id: string,
        requestBody?: PatchedTimeCardShiftRemove,
    }): CancelablePromise<TimeCardShift> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/timecard-shift/{id}/remove/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns TimeCardShift
     * @throws ApiError
     */
    public static assignmentsTimecardShiftRestorePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Time Card Shift.
         */
        id: string,
        requestBody?: PatchedTimeCardShift,
    }): CancelablePromise<TimeCardShift> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/timecard-shift/{id}/restore/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns TimeCardDetail
     * @throws ApiError
     */
    public static assignmentsTimecardRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this Time Card.
         */
        id: string,
    }): CancelablePromise<TimeCardDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/timecard/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns TimeCardDetail
     * @throws ApiError
     */
    public static assignmentsTimecardUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Time Card.
         */
        id: string,
        requestBody: TimeCardDetail,
    }): CancelablePromise<TimeCardDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assignments/timecard/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Handles the retrieval of change history for an instance.
     * The change history can be sorted in ascending or descending
     * order based on a query parameter.
     *
     * Args:
     * request: The HTTP request object.
     * *args: Additional positional arguments.
     * **kwargs: Additional keyword arguments.
     *
     * Returns:
     * Response: A Response object containing the aggregated and sorted change history
     * data for the instance.
     *
     * Note:
     * The `sort` query parameter is optional and determines the sort order of the
     * change history. Valid values are `asc` (ascending) and `desc` (descending).
     * @returns TimeCardShiftHistory
     * @throws ApiError
     */
    public static assignmentsTimecardChangeHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Time Card.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<TimeCardShiftHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/timecard/{id}/change-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns binary
     * @throws ApiError
     */
    public static assignmentsTimecardDocumentsZipRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this Time Card.
         */
        id: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/timecard/{id}/documents/zip/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns TimeCardEventHistory
     * @throws ApiError
     */
    public static assignmentsTimecardEventHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Time Card.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<TimeCardEventHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/timecard/{id}/event-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns PaginatedAssignmentExpenseListList
     * @returns AssignmentExpenseList
     * @throws ApiError
     */
    public static assignmentsTimecardExpensesList({
        id,
        assignment,
        endOnAfter,
        endOnBefore,
        healthcareEntity,
        limit,
        offset,
        ordering,
        queue,
        reason,
        search,
        startOnAfter,
        startOnBefore,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * A UUID string identifying this Time Card.
         */
        id: string,
        assignment?: string,
        endOnAfter?: string,
        endOnBefore?: string,
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * Reason
         */
        reason?: Array<string>,
        /**
         * A search term.
         */
        search?: string,
        startOnAfter?: string,
        startOnBefore?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedAssignmentExpenseListList | AssignmentExpenseList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/timecard/{id}/expenses/',
            path: {
                'id': id,
            },
            query: {
                'assignment': assignment,
                'end_on_after': endOnAfter,
                'end_on_before': endOnBefore,
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'reason': reason,
                'search': search,
                'start_on_after': startOnAfter,
                'start_on_before': startOnBefore,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
        });
    }

    /**
     * @returns PaginatedAssignmentExpenseListList
     * @returns AssignmentExpenseList
     * @throws ApiError
     */
    public static assignmentsTimecardExpensesCreate({
        id,
        requestBody,
        assignment,
        endOnAfter,
        endOnBefore,
        healthcareEntity,
        limit,
        offset,
        ordering,
        queue,
        reason,
        search,
        startOnAfter,
        startOnBefore,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * A UUID string identifying this Time Card.
         */
        id: string,
        requestBody: AssignmentExpenseCreate,
        assignment?: string,
        endOnAfter?: string,
        endOnBefore?: string,
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * Reason
         */
        reason?: Array<string>,
        /**
         * A search term.
         */
        search?: string,
        startOnAfter?: string,
        startOnBefore?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedAssignmentExpenseListList | AssignmentExpenseList> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/timecard/{id}/expenses/',
            path: {
                'id': id,
            },
            query: {
                'assignment': assignment,
                'end_on_after': endOnAfter,
                'end_on_before': endOnBefore,
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'reason': reason,
                'search': search,
                'start_on_after': startOnAfter,
                'start_on_before': startOnBefore,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PaginatedTimeCardNoteList
     * @returns TimeCardNote
     * @throws ApiError
     */
    public static assignmentsTimecardNotesList({
        id,
        assignment,
        endOnAfter,
        endOnBefore,
        healthcareEntity,
        limit,
        offset,
        ordering,
        queue,
        reason,
        search,
        sort,
        startOnAfter,
        startOnBefore,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * A UUID string identifying this Time Card.
         */
        id: string,
        assignment?: string,
        endOnAfter?: string,
        endOnBefore?: string,
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * Reason
         */
        reason?: Array<string>,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        startOnAfter?: string,
        startOnBefore?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedTimeCardNoteList | TimeCardNote> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/timecard/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'assignment': assignment,
                'end_on_after': endOnAfter,
                'end_on_before': endOnBefore,
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'reason': reason,
                'search': search,
                'sort': sort,
                'start_on_after': startOnAfter,
                'start_on_before': startOnBefore,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
        });
    }

    /**
     * @returns PaginatedTimeCardNoteList
     * @returns TimeCardNote
     * @throws ApiError
     */
    public static assignmentsTimecardNotesCreate({
        id,
        requestBody,
        assignment,
        endOnAfter,
        endOnBefore,
        healthcareEntity,
        limit,
        offset,
        ordering,
        queue,
        reason,
        search,
        sort,
        startOnAfter,
        startOnBefore,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * A UUID string identifying this Time Card.
         */
        id: string,
        requestBody: TimeCardNote,
        assignment?: string,
        endOnAfter?: string,
        endOnBefore?: string,
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `upcoming` - Upcoming
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `completed` - Completed
         * * `closed` - Closed
         * * `all` - All
         * * `provider_review` - Provider Review
         * * `needs_response` - Needs Response
         * * `approved` - Approved
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'approved' | 'awaiting_provider' | 'closed' | 'completed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'provider_review' | 'ready_for_clearance' | 'to_confirm' | 'upcoming',
        /**
         * Reason
         */
        reason?: Array<string>,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        startOnAfter?: string,
        startOnBefore?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedTimeCardNoteList | TimeCardNote> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/timecard/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'assignment': assignment,
                'end_on_after': endOnAfter,
                'end_on_before': endOnBefore,
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'reason': reason,
                'search': search,
                'sort': sort,
                'start_on_after': startOnAfter,
                'start_on_before': startOnBefore,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns TimeCardStatusHistory
     * @throws ApiError
     */
    public static assignmentsTimecardStatusHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Time Card.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<TimeCardStatusHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/timecard/{id}/status-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns TimeCardDetail
     * @throws ApiError
     */
    public static assignmentsTimecardStatusUpdatePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Time Card.
         */
        id: string,
        requestBody?: PatchedTimeCardStatusUpdate,
    }): CancelablePromise<TimeCardDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/timecard/{id}/status-update/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
